import React from 'react';
import {
  IonItem,
  IonLabel,
  IonSelect,
  IonSelectOption,
  IonList,
  IonText,
} from '@ionic/react';
import { chevronExpandOutline } from 'ionicons/icons';
import { useTranslation } from '../hooks/useTranslation';
import { supportedLanguages } from '../i18n';
import { useDeveloperModeQuery } from '../query/developerModeQuery';
import SectionHeader from './SectionHeader';
import sectionStyles from './SectionHeader.module.css';

const LanguageSwitcher: React.FC = () => {
  const { changeLanguage, currentLanguage } = useTranslation();
  const { t } = useTranslation('components');
  const { t: tCommon } = useTranslation('common');
  const { data: isDeveloperMode } = useDeveloperModeQuery();

  const handleLanguageChange = (language: string) => {
    console.log(`Switching language to: ${language}`);
    changeLanguage(language);
  };

  const getLanguageName = (lang: string) => {
    // Handle developer language
    if (lang === 'dev') {
      return 'Translation Developer';
    }
    // Handle language codes with regions (e.g., en-GB -> en)
    const baseLanguage = lang.split('-')[0];
    return tCommon(`language_names.${baseLanguage}`);
  };

  // Filter languages based on developer mode
  const availableLanguages = isDeveloperMode
    ? supportedLanguages
    : supportedLanguages.filter(lang => lang !== 'dev');

  return (
    <>
    <SectionHeader>{tCommon('language')}</SectionHeader>
    <IonList inset className={sectionStyles.insetList}>
      <IonItem button detail detailIcon={chevronExpandOutline}>
        <IonLabel>{t('language_switcher.select_language')}</IonLabel>
        <IonText slot="end" color="medium">
          {getLanguageName(currentLanguage)}
        </IonText>
        <IonSelect
          value={currentLanguage}
          placeholder={t('language_switcher.select_language')}
          onIonChange={(e) => handleLanguageChange(e.detail.value)}
          style={{ opacity: 0, position: 'absolute', width: '100%', height: '100%' }}
        >
          {availableLanguages.map((lang) => (
            <IonSelectOption key={lang} value={lang}>
              {getLanguageName(lang)} ({lang})
            </IonSelectOption>
          ))}
        </IonSelect>
      </IonItem>
    </IonList>
    </>
  );
};

export default LanguageSwitcher;